import {
  BANNER_MESSAGE_HIDE,
  BANNER_MESSAGE_SHOW,
  FLASH_MESSAGE_HIDE,
  FLASH_MESSAGE_SHOW,
} from '../../actionTypes/FlashMessage/FlashMessages';
import { USER_LOGOUT } from '../../actionTypes/Users/UserActionType';

const initialMsgState = {
  statusMsg: {
    msg: '',
    msgShow: false,
    pageLocation: '',
    msgType: 'NONE',
    boldMsg: '',
  },
  bannerMsg: {
    msg: '',
    msgShow: false,
  },
};

export default function flashMessagesReducer(state = { ...initialMsgState }, action) {
  switch (action.type) {
    case FLASH_MESSAGE_SHOW:
      return { ...state, statusMsg: { ...state.statusMsg, ...action.payload, msgShow: true } };

    case FLASH_MESSAGE_HIDE:
      return { ...state, statusMsg: { ...state.statusMsg, ...action.payload, msgShow: false } };

    case BANNER_MESSAGE_SHOW:
      return { ...state, bannerMsg: action.payload };

    case BANNER_MESSAGE_HIDE:
      return { ...state, bannerMsg: { ...initialMsgState.bannerMsg } };

    case USER_LOGOUT:
      return { ...state, ...initialMsgState };
    default:
      return state;
  }
}
